import axios from "axios";
import { offeredCategories } from "@/lib/categories";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(undefined, async (error) => {
  const cfg = error.config;
  if (error.response?.status !== 401 || !cfg || cfg._retried || cfg.url.startsWith("/auth/")) throw error;
  cfg._retried = true;
  refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
  try {
    await refreshing;
  } catch {
    window.dispatchEvent(new Event("auth:expired"));
    throw error;
  }
  return api(cfg);
});

export const cedi = (n) => `GH₵ ${Number(n || 0).toLocaleString("en-GH", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const cedi2 = cedi;
export const regClosed = (e) => e?.status === "Registration Closed" || (!!e?.registration_deadline && new Date(`${e.registration_deadline.slice(0, 16)}:00Z`) <= new Date());
export const fmtDeadline = (e) => new Date(`${e.registration_deadline.slice(0, 16)}:00Z`).toLocaleString("en-GB", { timeZone: "Africa/Accra", day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
export const balanceOf = (t) => Math.max(Math.round(((t.amount || 0) - (t.paid || 0)) * 100) / 100, 0);
export const overpaymentOf = (t) => Math.max(Math.round(((t.paid || 0) - (t.amount || 0)) * 100) / 100, 0);

export const showPin = (p) => (!p || String(p).startsWith("NOPIN-") ? "No AHPC PIN" : p);

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";

export const initials = (name = "") =>
  name.replace(/^Dr\.\s*/, "").split(" ").filter(Boolean).slice(0, 2).map((p) => p[0]).join("").toUpperCase();

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return `${d[0]?.loc?.slice(-2).join(" › ") || "Field"}: ${d[0]?.msg}`;
  if (d && typeof d === "object") return d.msg || "Something went wrong";
  return d || "Something went wrong";
};

export const minFee = (e) => { const fees = offeredCategories(e).map((c) => c.fee); return fees.length ? Math.min(...fees) : 0; };

export const shortId = () => Math.random().toString(36).slice(2, 10);
